// PreviewTester/utils/intentsApi.js

/**
 * Build the ingest base URL dynamically from env.
 * The `Origin` header is intentionally NOT set — browsers forbid it.
 * The browser sends the current page origin automatically, which is
 * exactly what the backend reads to route per env.
 */
const getIngestBase = () => {
  const region = process.env.REACT_APP_REGION || "us";
  const stage = process.env.REACT_APP_STAGE_ENV || "dev";
  const domain = process.env.REACT_APP_SL_BE_BASE_ENV_PART || "tezkit.com";
  return `https://${region}.autobot2.${domain}/${stage}`;
};

/**
 * Fetch available intents for a tenant + kb.
 *
 * @param {Object}  args
 * @param {string}  args.tenantId
 * @param {string}  args.kbId
 * @param {string} [args.region='us']
 * @returns {Promise<Array>} — array of intent objects
 */
export const fetchIntents = async ({ tenantId, kbId, region = "us" }) => {
  if (!tenantId || !kbId) {
    throw new Error("tenantId and kbId are required");
  }

  const task = `custom-intents/${tenantId}/${kbId}`;
  const url = `${getIngestBase()}/ai_ingest_sys?task=${encodeURIComponent(
    task,
  )}&region=${region}`;

  const token = localStorage.getItem("token") || "";

  const res = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "*/*",
      Authorization: token,

    },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch intents: ${res.status}`);
  }

  const data = await res.json();
  return Array.isArray(data.intents) ? data.intents : [];
};